import { alertConstants } from '../_constants';

export function alert(alert = {}, action) {
    switch (action.type) {
        case alertConstants.SUCCESS:
          return {
            type: action.type,
            message: action.message
          };
        case alertConstants.ERROR:
          return {
              type: action.type,
              message: action.message
          };
        case alertConstants.CLEAR:
            return {
                type: action.type,
                message: null
            };
        default:
          return alert
      }
}


// WEBPACK FOOTER //
// ./src/_reducers/alert.reducer.js